<template>
  <div class="e-supporters">
    <div class="e-supporters__supporters">
      <div>{{ $t('system.supportedBy') }}</div>
      <IconTelekom class="telekom" aria-label="Logo Telekom" />
    </div>
    <div class="e-supporters__promoters">
      <div>{{ $t('system.promotedBy') }}</div>
      <div class="e-supporters__promoters-list">
        <div>
          <IconBMFSFJ class="BMFSFSJ" aria-label="Logo BMFSFJ" />
        </div>
        <component class="pausentaste" :is="logo" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import IconTelekom from 'assets/icons_orig/logo-telekom.svg'
import IconBMFSFJ from 'assets/icons_orig/BMFSFJ.svg'
import Logopausentaste from 'atoms/Logo/LogoPausentaste'

export default {
  name: 'SupportersBar',
  components: {
    IconTelekom,
    IconBMFSFJ,
    Logopausentaste
  },
  computed: {
    ...mapGetters(['theme']),
    logo() {
      if (['pausentaste'].includes(this.theme)) {
        return 'Logo' + this.theme
      }
      return null
    }
  }
}
</script>

<style lang="scss">
@import '_assets/supporters';
</style>
